import check from './images/check.svg'

export default function CheckIcon() {
  return (
    <img src={check} alt="check" />
  )
}
